import React from 'react'
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import Draggable from 'react-draggable';
import ProjectListContainer from '../../../../containers/common/form/modal/ProjectListContainer'
import BootstrapDialog, { BootstrapDialogTitle } from '../../dialog/BootstrapDialog'


function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-project-dialog"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const ProjectModal = ({ title, open, handleClose, selectedProject }) => {
    return (
        <BootstrapDialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-project-dialog"
            fullWidth={true}
            maxWidth="lg"
        >
            <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-project-dialog" onClose={handleClose}>
                {title}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <ProjectListContainer handleClose={handleClose} selectedProject={selectedProject} />
            </DialogContent>
        </BootstrapDialog>
    )
}

export default ProjectModal